/**
 * Права модуля «Графики». Коды дублируются с бэком вручную, посимвольно —
 * см. Rost.Api/Security/Authorization/Functionality.cs
 */
export default {
    /** Плановый график работ: свой отдел */
    PROJECT_PLAN_READ: "PROJECT_PLAN_READ",
    /** Плановый график работ: все сотрудники */
    PROJECT_PLAN_READ_ALL: "PROJECT_PLAN_READ_ALL",
};
